import styled from 'styled-components';

export const ChevronHeaderSC = styled.div`
  display: grid;
  grid-template-columns: 15px 1fr;
  grid-column-gap: 18px;

  h3 {
    font-weight: 800;
    font-size: 20px;
    line-height: 30px;
  }

  svg {
    margin-right: 18px;
  }
`;
